<style>
.datepicker input {
  padding-right: 0 !important;
}

.ivu-table-cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
<template>
  <div class="conInner">
    <div class="white_box">
      <div class="box">
        <div class="top"></div>
        <div class="body">
          <div class="inner_con">
            <div class="portrait">
              <div class="userico">
                <img height="120" width="120" v-if="$store.getters.face&&$store.getters.face.length>0"
                  :src="$store.getters.face">
                <img v-else src="//static.kxymall.com/images/default_face.jpg" height="120" width="120">
              </div>
              <router-link class="uploadIco" to="/member/personalProfile">完善个人资料</router-link>
            </div>
            <dl class="baseStat">
              <dt>您好，<strong>{{$store.getters.name}}</strong>，欢迎回来！</dt>
              <dd>
                <span>等级：<em>{{memberName}}</em>
                  <router-link :to="{path: '/help', query: {articleid: 13}}" target="_blank">[如何升级]</router-link>
                </span>
                <span>等级积分：<em>{{stat.levelPoint}}</em></span>
              </dd>
              <!-- <dd>
                <span style=" margin-right:3px;">消费积分：<em>{{stat.costPoint}}</em></span>
                <span style=" margin-right:9px;">
                  <router-link to="/member/point" title="关于消费积分"><img
                      src="//static.kxymall.com/images/member_what_tp_03.png"></router-link>
                </span>
                <span style=" margin-right:3px;">冻结消费积分：<em>{{stat.freezePoint}}</em></span>
              </dd> -->
              <dd>
                <span style=" margin-right:3px;">首购积分：<em>{{stat.firstBuyPoint}}</em></span>
              </dd>
              <!-- <dd id="member_tip4" flag="none" style=" display:none;">
                <span class="member_tip"></span>
                <span class="member_tip2">您可以提前解冻被冻结的积分，但与被解冻积分的相关订单会置为完成状态，将不能进行退换货操作。<a
                    href="order.html?ordersList.status=6" style=" color:#2875C2;">我要去解冻</a></span>
                <span class="member_tip3"></span>
              </dd> -->
            </dl>
            <div class="myLinks">
              <div class="cr_admonishtop"></div>
              <span class="mlTop"></span>
              <div class="mlInner">
                <ul class="clearfix">
                  <li class="lnk1">
                    <router-link to="/member/comments"><strong>{{stat.commentCount}}条</strong>评论消息</router-link>
                  </li>
                  <li class="lnk2">
                    <router-link to="/member/order"><strong>{{stat.orderCount}}笔</strong>订单信息</router-link>
                  </li>
                  <li class="lnk3">
                    <!--<router-link to="/member/myAdvice"><em>{{stat.askCount}}条</em>咨询回复</router-link>-->
                    <a><em>{{stat.consultCount}}条</em>咨询回复</a>
                  </li>
                  <li class="lnk4">
                    <router-link to="/member/favorite?status=1"><strong>{{stat.favoriteCount}}个</strong>收藏商品
                    </router-link>
                  </li>
                </ul>
              </div>
              <span class="mlBtm"></span>
              <div class="cr_admonishbottom"></div>
            </div>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </div>
    <!-- 订单列表 -->
    <div class="box myorder" style="margin-top:10px">
      <div class="top order"></div>
      <div class="body">
        <Table class="order-table" style="border-top:none;" :columns="column" :data="orderList" no-data-text="尚无订单">
        </Table>
        <p class="oper clearfix">
          <router-link to="/member/order" class="checkAll">查看所有<strong>{{stat.orderCount}}</strong>笔订单</router-link>
        </p>
        <div class="clear"></div>
      </div>
      <div class="bottom"></div>
    </div>
    <!-- <div class="box" style="margin-top:10px">
      <div class="top order"></div>
      <div class="body">
        <h1>推荐商品</h1>
        <ul class="prodList">
          <li v-for="(item,index) in goodList" :key="index">
            <router-link :to="{path:'/goods',query:{goodsId:item.goodsId}}" target="_blank"><img :src="item.image"></router-link>
          </li>
          <div class="clear"></div>
        </ul>
      </div>
      <div class="bottom"></div>
    </div> -->
    <Modal v-model="cancelModal" width="530" title="请输入取消原因">
      <Input v-model="reason" type="textarea" :rows="4" style="width:480px;"></Input>
      <div slot="footer">
        <Button type="primary" size="large" @click="cancelOrder">确认取消订单</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getOrderList, orderCancel, rogConfirm, rogDelay, preCancelOrder } from 'api/order';
import { getUserStat, getUserRecommend } from 'api/user';
import { IMG_URL } from 'utils/url'
import { getSession } from "utils/tool";
export default {
  data() {
    return {
      cancelModal: false, // 取消原因弹框
      orderId: '', // 取消的订单ID
      reason: '', // 订单取消理由
      stat: {
        askCount: 0, //咨询回复
        commentCount: 0, // 评论消息
        costPoint: 0, // 消费积分
        favoriteCount: 0, // 收藏商品
        freezePoint: 0, // 冻结消费积分
        lvPoint: 0, //  等级积分
        orderCount: 0, // 订单信息
        firstBuyPoint: 0 // 收购积分
      },
      memberName: "",
      goodList: [],
      column: [{
        title: '订单号',
        align: 'center',
        width: 150,
        render: (h, params) => {
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({
                    path: '/member/orderInfo',
                    query: {
                      orderId: params.row.id,
                      isCod: params.row.onlinePay,
                      aux: params.row.auxState
                    }
                  })
                }
              }
            }, params.row.orderNo)
          ]);
        }
      }, {
        title: '下单日期',
        align: 'center',
        width: 120,
        key: 'createTime'
      }, {
        title: '收货人',
        align: 'center',
        width: 60,
        key: 'shipName'
      }, {
        title: '总金额',
        align: 'center',
        width: 70,
        key: 'orderAmount',
        render: (h, params) => {
          return h('span', params.row.orderAmount.toFixed(2));
        }
      }, {
        title: '状态',
        align: 'center',
        width: 90,
        key: 'statusText'
      }, {
        title: '付款方式',
        align: 'center',
        width: 120,
        key: 'paymentName'
      }, {
        title: '操作',
        align: 'center',
        key: 'name',
        render: (h, params) => {
          const playBtn = h('Button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                let routeData = this.$router.resolve({ path: '/pay', query: { orderId: params.row.id } });
                const tempwindow = window.open();
                tempwindow.location = routeData.href;
              }
            }
          }, '立即付款');
          const cancel = h('Button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                // if (params.row.status == '2' && params.row.sourceFlag == '4') { //已付款的订单 并且是首购商品
                //   this.$Message.error('首购专区商品已支付订单不能取消');
                //   return false;
                // }
                this.orderId = params.row.orderNo;
                //判断是否自营订单然后弹出确认提示
                if (params.row.isSelf == 1) {
                  preCancelOrder({ orderNo: params.row.orderNo }).then(({ resCode, resDesc, data }) => {
                    if (resCode === 1) {
                      this.cancelModal = true
                    } else {
                      this.cancelModal = false
                      this.$Message.warning(resDesc);
                    }
                  })
                } else {
                  this.cancelModal = true;
                }
              }
            }
          }, '取消订单');
          const sure = h('Button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                this.rogConfirm(params.row.orderNo);
              }
            }
          }, '确认收货');
          const delay = h('Button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                this.rogDelay(params.row.orderNo);
              }
            }
          }, '延迟收货');
          const change = h('Button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                this.$router.push({
                  path: '/member/returnList',
                  query: {
                    tab: 1
                  }
                })
              }
            }
          }, '申请退换货');
          const viewBtn =
            h('Button', {
              props: {
                type: 'text',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({
                    path: '/member/orderInfo',
                    query: {
                      orderId: params.row.orderId,
                      orderSn: params.row.orderNo,
                      isCod: params.row.onlinePay,
                      aux: params.row.auxState,
                    }
                  })
                }
              }
            }, '查看');
          let btns = [];
          if (params.row.status === 5) {
            if (params.row.auxState !== 3 && params.row.auxState !== 4) {
              btns.push(sure); // 确认收货
            }
            if (params.row.auxState === 0 && params.row.auxState === 5) {
              btns.push(delay); // 延迟收货
            }
          } else if (params.row.status === 7) {
            if (params.row.auxState === 0 || params.row.auxState === 5) {
              btns.push(change); // 申请退换货
            }
          } else if (params.row.status === 0) {
            if (params.row.onlinePay) {
              btns.push(playBtn); // 立即付款
            }
          } else if (params.row.status === 0 || params.row.status === 2) {
            if (params.row.auxState !== 5) {
              btns.push(cancel); // 取消订单
            }
          }
          btns.push(viewBtn);
          return h('div', btns);
        }
      }],
      orderList: []
    }
  },
  created() {
    this.memberName = getSession("membershipLevelName");
  },
  mounted() {
    this.$nextTick(() => {
      // 获取统计信息
      this.getUserStat();
      // 获取推荐商品
      //this.getUserRecommend();
      // 获取订单信息
      this.getOrderList();
    })
  },
  methods: {
    // 获取订单信息
    getOrderList() {
      getOrderList({
        status: '',
        keyword: '',
        page: 1,
        pageSize: 10
      }).then(resp => {
        if (resp.resCode === 1) {
          this.orderList = resp.data.list;
        }
      });
    },
    // 延迟收货
    rogDelay(id) {
      this.$Modal.confirm({
        content: '<p>请您确认是否延迟?将推迟4天打款给卖家！</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          rogDelay({ orderNo: id }).then(resp => {
            if (resp.resCode === 1) {
              this.$Message.success("订单确认延迟成功");
              this.getOrderList();
            } else {
              this.$Message.error(resp.resDesc);
            }
          })
        },
        onCancel: () => {
        }
      });
    },
    // 取消订单
    cancelOrder() {
      setTimeout(() => {
        if (this.reason.trim() === '') {
          this.$Message.warning('订单取消原因不能为空');
        } else {
          orderCancel({
            orderNo: this.orderId,
            reason: this.reason
          }).then(resp => {
            if (resp.resCode === 1) {
              this.$Message.success("订单取消成功");
              this.getOrderList();
              setTimeout(() => {
                this.cancelModal = false;
              }, 500);
            } else {
              this.$Message.error(resp.resDesc);
            }
            this.reason = '';
          })
        }
      }, 100)
    },
    // 订单确认收货
    rogConfirm(id) {
      this.$Modal.confirm({
        content: '<p>请您确认已经收到货物再执行此操作</p>',
        okText: '已收取',
        cancelText: '再去确认一下',
        onOk: () => {
          rogConfirm({ orderNo: id }).then(resp => {
            if (resp.resCode === 1) {
              this.$Message.success("订单已确认收货");
              this.getOrderList();
            } else {
              this.$Message.error(resp.resDesc);
            }
          })
        },
        onCancel: () => {
        }
      });
    },
    // 获取统计信息
    getUserStat() {
      getUserStat().then(resp => {
        if (resp.resCode === 1) {
          this.stat = resp.data;
        }
      })
    },
    // 获取推荐商品
    getUserRecommend() {
      getUserRecommend({}).then(resp => {
        if (resp.resCode === 1) {
          this.goodList = [];
          resp.data.forEach(i => {
            this.goodList.push({
              goodsId: i.goodsId,
              image: `${IMG_URL}/${i.small}`
            })
          })
        }
      })
    },
  }
}
</script>


<style scoped>
.box {
  top: 0;
  float: left;
  position: relative;
  z-index: 1;
}

.box .top {
  background: url(//static.kxymall.com/images/hybs.jpg) no-repeat left
    top;
  height: 8px;
  width: 753px;
}

.box .order {
  width: 753px;
  height: 8px;
  background: url(//static.kxymall.com/images/hylyt.jpg) no-repeat left
    top;
  overflow: hidden;
}

.box .body {
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  width: 751px;
}

.box h1 {
  background-color: #eeeeee;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  padding-left: 20px;
}

.white_box .inner_con {
  padding: 5px 27px;
  width: 697px;
  overflow: hidden;
  background-color: #fff;
}

.white_box .portrait {
  width: 122px;
  margin-right: 36px;
  float: left;
  display: inline;
}

.white_box .portrait .userico {
  width: 122px;
  height: 120px;
  margin-bottom: 7px;
}

.white_box .portrait .userico img {
  width: 120px;
  height: 118px;
  border: 1px solid #ccc;
}

.white_box .portrait a {
  display: block;
  color: #000;
  width: 86px;
  padding-left: 34px;
  line-height: 17px;
  background: url(//static.kxymall.com/images/yxsc.jpg) no-repeat left
    top;
}

.white_box .baseStat {
  width: 314px;
  float: left;
  display: inline;
  overflow: hidden;
  margin-right: 30px;
}

.white_box .baseStat dt {
  width: 304px;
  line-height: 29px;
  height: 29px;
  color: #6b6b6b;
  background-color: #eee;
  padding-left: 10px;
  font-size: 14px;
}

.white_box .baseStat dd {
  width: 314px;
  height: 32px;
  line-height: 32px;
  border-bottom: 1px dashed #bdbdbd;
  color: #6c6c6c;
}

.white_box .baseStat dd a {
  color: #a4a4a4;
}

.myLinks {
  width: 193px;
  float: left;
  display: inline;
  background-color: #eee;
}

.myLinks .cr_admonishtop {
  width: 193px;
  height: 5px;
  background: url(//static.kxymall.com/images/hysys.jpg) no-repeat left
    top;
}

.myLinks .cr_admonishbottom {
  width: 193px;
  height: 5px;
  background: url(//static.kxymall.com/images/hysyx.jpg) no-repeat left
    top;
}

.myLinks .mlInner {
  padding: 10px 0px 10px 22px;
  width: 169px;
  overflow: hidden;
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
}

.myLinks .mlInner .clearfix {
  width: 169px;
  overflow: hidden;
}

.myLinks .mlInner .clearfix li {
  padding-left: 35px;
  width: 134px;
  height: 37px;
  line-height: 37px;
  color: #53a0be;
}

.myLinks .mlInner .clearfix .lnk1 {
  background: url(//static.kxymall.com/images/tdlibj.jpg) no-repeat left
    13px;
}

.myLinks .mlInner .clearfix .lnk2 {
  background: url(//static.kxymall.com/images/tdlibj.jpg) no-repeat left -25px;
}

.myLinks .mlInner .clearfix .lnk3 {
  background: url(//static.kxymall.com/images/tdlibj.jpg) no-repeat left -65px;
}

.myLinks .mlInner .clearfix .lnk4 {
  background: url(//static.kxymall.com/images/tdlibj.jpg) no-repeat left -108px;
}

.myLinks .mlInner .clearfix li a {
  color: #53a0be;
}

.myLinks .mlInner .clearfix li a strong {
  color: #ed7108;
  margin-right: 2px;
}

.myLinks .mlInner .clearfix li a em {
  color: #ed7108;
  margin-right: 2px;
  font-weight: bold;
}

.box .bottom {
  width: 753px;
  height: 8px;
  background: url(//static.kxymall.com/images/hybx.jpg) no-repeat left
    top;
}

/**
  首页订单
  **/
.myorder p {
  width: 751px;
  height: 36px;
  line-height: 36px;
  background-color: #fff;
}

.myorder p #cancalOrder {
  text-decoration: underline;
  color: #53a0be;
  margin-left: 20px;
}

.myorder p .checkAll {
  float: right;
  display: inline;
  margin-right: 13px;
  color: #53a0be;
}

.myorder p .checkAll strong {
  color: #ed7108;
  margin: 0px 3px;
}

.hovertr a {
  color: #53a0be;
}

.prodList {
  background-color: #fff;
  padding: 21px 0px 0px 39px;
  overflow: hidden;
}

.prodList li {
  width: 152px;
  height: 240px;
  float: left;
  display: inline;
  overflow: hidden;
  margin: 0 21px 28px 0;
  text-align: center;
}

.prodList li a {
  display: block;
}

.prodList li span {
  display: block;
}

.prodList li img {
  width: 152px;
  height: 240px;
  border: 1px solid #ccccce;
}

.prodList li .title {
  font-size: 14px;
  width: 152px;
  height: 25px;
  overflow: hidden;
  line-height: 25px;
  color: #7a7a7a;
  white-space: nowrap;
  font-weight: normal;
}

.prodList li .oPrice {
  width: 153px;
  height: 20px;
  line-height: 20px;
  color: #7a7a7a;
  font-weight: normal;
}

.prodList li .oPrice em {
  text-decoration: line-through;
}

.prodList li .price {
  width: 152px;
  height: 20px;
  line-height: 20px;
  color: #7a7a7a;
  font-size: 13px;
}

.prodList li .price strong {
  color: #ed7108;
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// member.vue?319d1bd6